// University → Colleges mapping
// Colleges populate based on selected university.
// For universities without a specific list, a free-text input is shown instead.

export const UNIVERSITIES = [
  {
    id: "veer-kunwar-singh",
    name: "Veer Kunwar Singh University",
    colleges: [
      "Al Hafeez College",
      "Amarnath Mishra Degree Mahavidyalaya, Dayalpur, Dhansoi, Buxar",
      "Anjabit Singh College, Bikramganj, Rohtas",
      "Awadhoot Bhagwan Ram College, Sasaram",
      "B.G College, Dehari on Sone, Jamuhar, Rohtas",
      "B.G. College, Ramlal Nagar, Bhabhua, Kaimur",
      "B.K.S. College, Kuddi, Chand, Kaimur",
      "B.N. Bhagat Lalan Singh Degree College, Itarhi, Buxar",
      "B.N. College, Indour, Sasaram, Rohtas",
      "B.S. College, Hata, Chenari, Rohtas",
      "B.S.S. College Bachari, Piro, Ara",
      "Baba Heera Singh Deep Singh Jee College of Higher Education, Kothuan, Agion Bazar, Piro, Bhojpur",
      "Bindeshwari Dubey Mahavidyalaya Bihiya Kataiya, Bhojpur",
      "Chanakya Academy Mahila Mahavidyalaya, Sarenja, Rajpur, Buxar",
      "Chaudhary Charan Singh College, Rajpur, Rohtas",
      "Chaudhary Charan Singh Evening College, Bhagirtha-Narwar, Kochas, Rohtas",
      "D.D College (Dhanupra) ARA",
      "D.K. College, Dumraon",
      "D.K.M. College, Dumari, Buxar",
      "D.S.S.V. College, Simri, Buxar",
      "Dharikshan Shanti Meera Sidhnath Degree Mahavidyalaya, Kulhariya, Bhojpur",
      "Dr. K.K. Mandal College, Jagdishpur, Bhojpur",
      "Dr. K.K. Mandal Mahila College, Buxar",
      "Durgawati Mahavidyalaya, Bichhiya, Dumari, Kaimur",
      "G.B. College, Ramgarh",
      "Geeta Pradeep College of Higher Education, Asani, Bhojpur",
      "Girish Narayan Mishra College, Parsathua, Rohtas",
      "Gram Bharti Balika Vidyapeeth, Ramgarh, Kaimur",
      "Guriya Singh Sanjay College, Nahar Road, Jagdishpur, Bhojpur",
      "Guru Prakash College, Kekadha, Kilani, Kaimur",
      "H.N.S.B. Janta College, Dhansoi, Buxar",
      "Harprasad Das Jain College, Ara",
      "I.D.B.P. Singh College, Garh Nokha",
      "Indra Parashuram Singh Mahavidyalaya, Maidan Kala, Belaon, Kaimur",
      "Indra Parashuram Singh Mahila Mahavidyalaya, Chilbili Kudra, Kaimur",
      "Indu Tapeshwar Singh Mahila College, Bikramganj, Rohtas",
      "J.D.S. Degree College, Diliyan, Tarari, Bhojpur",
      "Jagdeo Memorial College, Sakari Kudra, Kaimur",
      "Jagjiwan College, Arrah, Bhojpur",
      "Jagjiwan College, Dehri-on-Sone, Rohtas",
      "Jan Sahakari D.C. Barap, Garahni, Bhojpur",
      "Jawahar Lal Nehru College, Rohtas",
      "K.N.S. College, Itarhi Road, Buxar",
      "Keshari Devi Mahavidyalay, Khakhan Tola, Khawaspur, Bhojpur",
      "L.B.G.T. College, Buxar",
      "Lalu Prasad Yadav College, Akodhi, Gola",
      "M.C. College, Chausa, Buxar",
      "M.D. Saif Degree College, Ghosia Kalan, Bikramganj, Rohtas",
      "M.D.R.P.D.M. College, Bhabhua, Kaimur",
      "M.P. College, Mohania",
      "M.V. College, Buxar",
      "Mahanth Mahadevanand Mahila Mahavidyalaya, Ara",
      "Maharaja College, Ara",
      "Mahatma Gandhi College, Lahrabad Peero, Bhojpur",
      "Mahila College, Dalmianagar, Rohtas",
      "Mata Manjharo Ajab Dayal Singh College, Jagdishpur, Bhojpur",
      "Mauni Baba Yamuna Das Lakhrajo Devi Mahila College, Bikramganj",
      "P.C. College, Buxar",
      "Patel College, Ghushiya Khurd",
      "Payhari Maharaj Ji College, Ara, Bhojpur",
      "Pr.B.P.Singh College, Semari, Rohtas",
      "R.K. Institute of Higher Education, Jaddupur, Kaimur (Bhabhua), Bihar",
      "R.M. Devi C.D. Rai College, Nawan Kochas",
      "R.S.D. College, Bhagwanpur, Kaimur",
      "R.S.M. Degree College, Santpur, Dhanupra, Ara",
      "Radha Shanta College, Tilauthoo, Rohtas",
      "Ram Kishor Singh College, Dalmianagar, Rohtas",
      "Ram Nagina Singh College, Ararua, Akodhi, Karhagar, Rohtas",
      "Ram Narayan Sah Sarvoday College, Ganj Bhadasra, Sasaram, Rohtas",
      "Ramawtar Singh Adarsh Mahavidyalaya, Bijhaura, Buxar",
      "Rohtas Mahila College, Sasaram, Rohtas",
      "S.B. College, Ara",
      "S.M. College, Dumraon",
      "S.N. College, Shahmal Khaira-Deo, Rohtas",
      "S.S.S. College, Dinara, Rohtas",
      "S.S.S. Mahila College, Bhabhua",
      "S.T.S.M. College, Panwari, Bhojpur",
      "S.V.P. College, Bhabhua, Kaimur",
      "Sant Shri Brahma Mahila College, Jagdishpur",
      "Seema Kumari College, Itarhi Road, Turkpurwa, Buxar",
      "Shanti Prasad Jain College, Sasaram, Rohtas",
      "Shersbah College, Sasaram, Rohtas",
      "Shivgovind Nandlal Singh Degree Mahavidyalay, Sikraul Lock, Dafadihari, Buxar",
      "Shri Shankar College, Sasaram, Rohtas",
      "Shrimati Prabhawati Vidyabhusan College, Bhabhua",
      "Sidhnath Sah College, Baghelwa (Tiyara), Rajpur, Buxar",
      "Sri Tridandi Dev Govt. Degree College, Gautam Nagar, Shahpur, Bhojpur",
      "Sub Divisional Government College, Nauhatta, Rohtas",
      "Sunil Singh Yadav Degree College, Indrahiyan, Sasaram, Rohtas",
      "Swami Shivanand Jee Tirth College, Sasaram, Rohtas",
      "Tapeshwar Singh Indu Mahila Mahavidyalaya, Arrah, Bhojpur",
      "Tara Shivshankar Degree College, Tiyara, Buxar",
      "V.P.J.P.S. Mahila College, Rajpur, Rohtas",
      "Veer Kunwar Singh College, Jagdishpur, Bhojpur",
      "Veer Kunwar Singh Mahavidhyalya, Dharupur, Bikramganj, Rohtas",
      "Veer Kunwar Singh Mahila College, Kashi Medinipur, Nasriganj, Rohtas",
    ],
  },
  { id: "patliputra", name: "Patliputra University", colleges: [] },
  { id: "patna", name: "Patna University", colleges: [] },
  { id: "lnmu", name: "Lalit Narayan Mithila University, Darbhanga", colleges: [] },
  { id: "tmbu", name: "T.M. Bhagalpur University, Bhagalpur", colleges: [] },
  { id: "munger", name: "Munger University, Munger", colleges: [] },
  { id: "brabu", name: "B.R.A. Bihar University, Muzaffarpur", colleges: [] },
  { id: "bnmu", name: "B.N. Mandal University, Madhepura", colleges: [] },
  { id: "purnea", name: "Purnea University, Purnea", colleges: [] },
  { id: "jpu", name: "Jai Prakash University, Chapra", colleges: [] },
  { id: "nou", name: "Nalanda Open University", colleges: [] },
  { id: "mgu-kerala", name: "Mahatma Gandhi University, Kerala", colleges: [] },
  { id: "other", name: "Other University", colleges: [] },
];

export const getColleges = (universityId) => {
  const u = UNIVERSITIES.find((x) => x.id === universityId);
  return u ? u.colleges : [];
};
